import { render, staticRenderFns } from "./tourist.vue?vue&type=template&id=ed7f80f8&scoped=true"
import script from "./tourist.vue?vue&type=script&lang=js"
export * from "./tourist.vue?vue&type=script&lang=js"
import style0 from "./tourist.vue?vue&type=style&index=0&id=ed7f80f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7f80f8",
  null
  
)

export default component.exports